import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthV2Service } from './auth-v2.service';
import { LoggerService } from '../logger.service';
import { RestModule } from '../rest/rest.module';

@NgModule({
  imports: [CommonModule, RestModule],
  providers: [
    LoggerService,
    AuthV2Service,
  ],
})
export class AuthV2Module {}
